module.exports = __webpack_public_path__ + "static/assets/e5750bfc0c4b12a5c292c313c63df53a.svg";